/* eslint-disable no-warning-comments */
// 剧目销售看板 - 各接口 mock（保留旧 mock 风格，仅作为开发期 fallback）
// 数据格式严格对齐接口文档 2026-09-01-show-sales-dashboard-frontend-api.md
//   { code: 0, message: 'success', data: <业务数据> }
// 真实接口上线后请在 models/perform_sales.js 把 useMock 置为 false
import dayjs from 'dayjs';

function seed(n, base, amp) {
  const a = [];
  for (let i = 0; i < n; i++) {
    a.push(Math.round(base + Math.sin(i / 2.8) * amp + (i % 5) * amp * 0.08));
  }
  return a;
}

const DAYS = 30;
const labs = Array.from({ length: DAYS }, (_, i) => {
  const d = dayjs().subtract(DAYS - 1 - i, 'day');
  return d.format('YYYY-MM-DD');
});

const AVG_PRICE = 992;
const TICKETS_PER_BUYER = 1.54;
const TSJ_SHARE = 0.703;
const MY_SHARE = 0.184;
const DETAIL_UV_CONV = 0.067;

const pv = seed(DAYS, 6200, 1400);
const uv = pv.map((v, i) => Math.round(v * (0.52 + (i % 7) * 0.01)));
const paid = seed(DAYS, 520000, 160000);
// 早鸟按日分布，与总览 birdAmount 总数相近
const bird = seed(DAYS, 260000, 90000);

const sum = (arr) => arr.reduce((x, y) => x + y, 0);
const pvTotal = sum(pv);
const amount = sum(paid);
const totalTickets = Math.round(amount / AVG_PRICE);
const buyers = Math.round(totalTickets / TICKETS_PER_BUYER);

const chTsj = Math.round(totalTickets * TSJ_SHARE);
const chMy = Math.round(totalTickets * MY_SHARE);
const chDm = totalTickets - chTsj - chMy;
const tsjAmtWan = (chTsj * AVG_PRICE) / 10000;
const myAmtWan = (chMy * AVG_PRICE) / 10000;
const dmAmtWan = (chDm * AVG_PRICE) / 10000;
const tsjAmtWanRounded = Number(tsjAmtWan.toFixed(2));
const myAmtWanRounded = Number(myAmtWan.toFixed(2));
const dmAmtWanRounded = Number(dmAmtWan.toFixed(2));

const tsjBuyers = Math.round(chTsj / TICKETS_PER_BUYER);
const detailUv = Math.round(tsjBuyers / DETAIL_UV_CONV);

const vipTickets = Math.round(chTsj * 0.2);
const vipBuyers = Math.round(vipTickets / 1.62);
const vipBirdAmount = Math.round(vipTickets * AVG_PRICE * 1.2 * 0.5);
const vipPayable = Math.round(vipTickets * AVG_PRICE * 1.2);
const tsjBirdAmount = Math.round(tsjAmtWan * 10000);
const vipBirdRate = tsjBirdAmount > 0 ? vipBirdAmount / tsjBirdAmount : 0;

// ===== 0. 剧目搜索 =====
// TODO 剧目下拉接口数据返回 proNo/proName，是否文广票池字段未给；前端先用 proNo 判定 wentIncluded：10004594=文广，其它=非文广
const SHOWS = [
  { proNo: '100001', proName: '剧院魅影' },
  { proNo: '100002', proName: '歌剧魅影' },
  { proNo: '100003', proName: '猫' },
  { proNo: '100004', proName: '悲惨世界' },
  { proNo: '100005', proName: '西区故事' },
  { proNo: '100006', proName: '白夜行' },
  { proNo: '10004594', proName: '双城之战测试剧目' },
];

// ===== 1. 销售总览 =====
function makeOverviewItems() {
  return [
    {
      index: 'SHOW_TICKET_CNT',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(totalTickets) }],
    },
    {
      index: 'SHOW_BUYERS',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(buyers) }],
    },
    {
      index: 'SHOW_BIRD_AMOUNT',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(tsjBirdAmount) }],
    },
    {
      index: 'SHOW_PAYABLE',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(Math.round(amountYuan)) }],
    },
    {
      index: 'SHOW_TICKET_PER_BUYER',
      timeDimension: 'ALL',
      values: [
        { valueType: 'VALUE', value: (totalTickets / buyers).toFixed(2) },
      ],
    },
  ];
}

// ===== 2. VIP =====
function makeVipItems() {
  return [
    {
      index: 'SHOW_VIP_BUYERS',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(vipBuyers) }],
    },
    {
      index: 'SHOW_VIP_TICKET_CNT',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(vipTickets) }],
    },
    {
      index: 'SHOW_VIP_BIRD_AMOUNT',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(vipBirdAmount) }],
    },
    {
      index: 'SHOW_VIP_PAYABLE',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(vipPayable) }],
    },
    {
      index: 'SHOW_VIP_BIRD_RATE',
      timeDimension: 'ALL',
      values: [{ valueType: 'RATE', value: vipBirdRate.toFixed(4) }],
    },
  ];
}

// ===== 3. 趋势 =====
function makeTrendItems() {
  const pvRows = labs.map((lab, i) => ({
    index: 'SHOW_DETAIL_PV',
    timeDimension: 'DAY',
    values: [
      { valueType: 'LABEL', value: lab },
      { valueType: 'VALUE', value: String(pv[i]) },
    ],
  }));
  const uvRows = labs.map((lab, i) => ({
    index: 'SHOW_DETAIL_UV',
    timeDimension: 'DAY',
    values: [
      { valueType: 'LABEL', value: lab },
      { valueType: 'VALUE', value: String(uv[i]) },
    ],
  }));
  const paidRows = labs.map((lab, i) => ({
    index: 'SHOW_DAILY_PAID',
    timeDimension: 'DAY',
    values: [
      { valueType: 'LABEL', value: lab },
      { valueType: 'VALUE', value: String(paid[i]) },
    ],
  }));
  const birdRows = labs.map((lab, i) => ({
    index: 'SHOW_DAILY_BIRD',
    timeDimension: 'DAY',
    values: [
      { valueType: 'LABEL', value: lab },
      { valueType: 'VALUE', value: String(bird[i]) },
    ],
  }));
  return [...pvRows, ...uvRows, ...paidRows, ...birdRows];
}

// ===== 4. 漏斗 =====
const FUNNEL_STEPS = [
  { code: 'DETAIL', n: detailUv },
  { code: 'CALENDAR', n: Math.round(detailUv * 0.498) },
  { code: 'SEAT', n: Math.round(detailUv * 0.275) },
  { code: 'CONFIRM', n: Math.round(detailUv * 0.154) },
  { code: 'DEAL', n: tsjBuyers },
];

function makeFunnelItems() {
  const uvItems = FUNNEL_STEPS.map((s) => ({
    index: 'SHOW_FUNNEL_UV',
    timeDimension: 'ALL',
    values: [
      { valueType: 'LABEL', value: s.code },
      { valueType: 'VALUE', value: String(s.n) },
    ],
  }));
  const stepItems = FUNNEL_STEPS.map((s, i) => {
    const item = {
      index: 'SHOW_FUNNEL_STEP_RATE',
      timeDimension: 'ALL',
      values: [{ valueType: 'LABEL', value: s.code }],
    };
    if (i > 0) {
      const prev = FUNNEL_STEPS[i - 1].n || 1;
      item.values.push({
        valueType: 'RATE',
        value: (s.n / prev).toFixed(4),
      });
    }
    return item;
  });
  const detailItems = FUNNEL_STEPS.map((s) => {
    const rateVal = detailUv > 0 ? (s.n / detailUv).toFixed(4) : '0.0000';
    return {
      index: 'SHOW_FUNNEL_DETAIL_RATE',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: s.code },
        { valueType: 'RATE', value: rateVal },
      ],
    };
  });
  return [...uvItems, ...stepItems, ...detailItems];
}

// ===== 5. 地域 =====
const GEO = [
  { name: '上海', p: 0.523 },
  { name: '江苏', p: 0.128 },
  { name: '浙江', p: 0.096 },
  { name: '北京', p: 0.054 },
  { name: '广东', p: 0.042 },
  { name: 'OTHER', p: 0.157 },
];

function makeRegionItems() {
  const items = [
    {
      index: 'SHOW_REGION_PV_TOTAL',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(pvTotal) }],
    },
    {
      index: 'SHOW_REGION_SH_RATE',
      timeDimension: 'ALL',
      values: [{ valueType: 'RATE', value: GEO[0].p.toFixed(4) }],
    },
    {
      index: 'SHOW_REGION_OUTER_RATE',
      timeDimension: 'ALL',
      values: [{ valueType: 'RATE', value: (1 - GEO[0].p).toFixed(4) }],
    },
  ];
  GEO.forEach((g) => {
    items.push({
      index: 'SHOW_REGION_CITY',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: g.name },
        { valueType: 'VALUE', value: String(Math.round(pvTotal * g.p)) },
        { valueType: 'RATE', value: g.p.toFixed(4) },
      ],
    });
  });
  return items;
}

// ===== 6. 场次 =====
const SESSION_N = 80;
const SLOW_SET = {
  6: 1,
  13: 1,
  27: 1,
  34: 1,
  48: 1,
  55: 1,
  61: 1,
  69: 1,
  74: 1,
  78: 1,
};

const sess = [];
const start = dayjs('2026-09-12');
for (let s = 0; s < SESSION_N; s++) {
  let sold, remain;
  if (SLOW_SET[s]) {
    sold = Math.round(360 + Math.sin(s / 3) * 70 + (s % 4) * 22);
    remain = Math.round(820 + Math.cos(s / 5) * 90 + (s % 3) * 40);
  } else {
    sold = Math.round(1020 + Math.sin(s / 5.5) * 180 + (s % 7) * 22);
    remain = Math.round(210 - Math.sin(s / 5.5) * 90 + (s % 5) * 26);
  }
  if (remain < 20) {
    remain = 20;
  }
  if (sold < 60) {
    sold = 60;
  }
  const d = start.add(s, 'day');
  sess.push({
    id: `${10026000 + s}`,
    sold,
    remain,
    time: `${d.format('YYYY-MM-DD')} 19:30`,
  });
}
let totalSold = 0;
let totalRemain = 0;
sess.forEach((x) => {
  totalSold += x.sold;
  totalRemain += x.remain;
});

function makeSessionItems() {
  const items = [
    {
      index: 'SHOW_SESSION_COUNT',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(sess.length) }],
    },
    {
      index: 'SHOW_SESSION_SOLD',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(totalSold) }],
    },
    {
      index: 'SHOW_SESSION_LEFT',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: String(totalRemain) }],
    },
  ];
  sess.forEach((x) => {
    items.push({
      index: 'SHOW_SESSION_BAR_SOLD',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: x.id },
        { valueType: 'VALUE', value: String(x.sold) },
      ],
    });
    items.push({
      index: 'SHOW_SESSION_BAR_LEFT',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: x.id },
        { valueType: 'VALUE', value: String(x.remain) },
      ],
    });
    items.push({
      index: 'SHOW_SESSION_BAR_TIME',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: x.id },
        { valueType: 'VALUE', value: x.time },
      ],
    });
  });
  return items;
}

// ===== 7. 渠道 =====
// TODO 剧目是否文广票池由前端根据 proNo 判定：10004594=文广，其它=非文广
function makeChannelItems(wentIncluded) {
  if (!wentIncluded) {
    return [
      {
        index: 'SHOW_CHANNEL_WENT_PLAY',
        timeDimension: 'ALL',
        values: [{ valueType: 'VALUE', value: '0' }],
      },
      {
        index: 'SHOW_CHANNEL_TICKET',
        timeDimension: 'ALL',
        values: [{ valueType: 'LABEL', value: 'TSJ' }],
      },
      {
        index: 'SHOW_CHANNEL_TICKET',
        timeDimension: 'ALL',
        values: [{ valueType: 'LABEL', value: 'MAOYAN' }],
      },
      {
        index: 'SHOW_CHANNEL_TICKET',
        timeDimension: 'ALL',
        values: [{ valueType: 'LABEL', value: 'DAMAI' }],
      },
    ];
  }
  const rows = [
    { code: 'TSJ', tickets: chTsj, amount: tsjAmtWanRounded },
    { code: 'MAOYAN', tickets: chMy, amount: myAmtWanRounded },
    { code: 'DAMAI', tickets: chDm, amount: dmAmtWanRounded },
  ];
  const total = rows.reduce((s, r) => s + r.tickets, 0) || 1;
  const items = [
    {
      index: 'SHOW_CHANNEL_WENT_PLAY',
      timeDimension: 'ALL',
      values: [{ valueType: 'VALUE', value: '1' }],
    },
  ];
  rows.forEach((r) => {
    items.push({
      index: 'SHOW_CHANNEL_TICKET',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: r.code },
        { valueType: 'VALUE', value: String(r.tickets) },
      ],
    });
    items.push({
      index: 'SHOW_CHANNEL_PAID',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: r.code },
        { valueType: 'VALUE', value: String(r.amount) },
      ],
    });
    items.push({
      index: 'SHOW_CHANNEL_TICKET_RATE',
      timeDimension: 'ALL',
      values: [
        { valueType: 'LABEL', value: r.code },
        { valueType: 'RATE', value: (r.tickets / total).toFixed(4) },
      ],
    });
  });
  return items;
}

const delay = (data) =>
  new Promise((resolve) => setTimeout(() => resolve({ data }), 80));

// ===== 对外 mock =====
export const mockQueryShowList = () => delay(SHOWS);

export const mockQueryShowOverview = () =>
  delay({
    proNo: 'mock',
    showName: '剧院魅影（mock）',
    dataAsOf: dayjs().format('YYYY-MM-DD HH:mm'),
    visitDataAsOf: null,
    wentIncluded: false,
    items: makeOverviewItems(),
  });

export const mockQueryShowVip = () =>
  delay({
    dataAsOf: dayjs().format('YYYY-MM-DD HH:mm'),
    items: makeVipItems(),
  });

export const mockQueryShowVisitSalesTrend = () =>
  delay({
    dataAsOf: dayjs().format('YYYY-MM-DD HH:mm'),
    visitDataAsOf: dayjs().format('YYYY-MM-DD HH:mm'),
    items: makeTrendItems(),
  });

export const mockQueryShowFunnel = () => delay({ items: makeFunnelItems() });

export const mockQueryShowRegionTop = () =>
  delay({
    dataAsOf: dayjs().format('YYYY-MM-DD HH:mm'),
    items: makeRegionItems(),
  });

export const mockQueryShowSessionStack = () =>
  delay({
    dataAsOf: dayjs().format('YYYY-MM-DD HH:mm'),
    items: makeSessionItems(),
  });

export const mockQueryShowChannel = (param) => {
  // TODO 剧目是否文广票池由前端根据 proNo 判定；此处按 proNo 简单判断
  const proNo = param?.proNo;
  const wentIncluded = proNo === '10004594';
  return delay({
    proNo,
    dataAsOf: null,
    wentIncluded,
    items: makeChannelItems(wentIncluded),
  });
};
